"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolveClass = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
function useResolveClass(Binding, args, scope) {
    if (args === void 0) { args = []; }
    return react_1.useMemo(function () {
        return di_1.default.getInstance(Binding, args, scope);
    }, []);
}
exports.useResolveClass = useResolveClass;
